<template>
  <div class="Home">

	<div v-if="pages" style="float:left;margin-left:10px;">
	Pages: <span v-for="n in pages+1" class="pageNumber" @click="changePage(n)" :name="'page'+n">{{n}}</span></div>
  
	<div v-if="searchResults.length||searchResult.length" style="float:left;margin-left:10px;">Found ({{ searchResults.length||searchResult.length }})</div><br><br>
	
	<div v-if="searchResult.length" v-for="(item,index) in searchResult" class="searchOuter">
		
		<div class="searchItem" @click.self="toggle(index)">
			<button class="editButton">EDIT</button>
			<button class="editButton" @click="download(item.path,item.location)">DOWNLOAD</button>
			
			<div class="searchItemName" @click="toggle(index)"><p class="location">[{{ item.location}}]</p> <b>{{ item.name }}</b> </div>
			File Path: {{ item.path }}
			
			<transition name="dropdown">
			<div v-if="show[index]" class="itemProperties">
				<table v-if="searchOccurs">
					<tr v-for="location in item.multiple">
						<td class="tField location">{{location.location}}</td><td>{{location.path}}</td>
					</tr>
				</table>
				<table v-else>
					<table width="500" style="display:inline">
						<tr><td class="tField">Location</td><td>{{item.location}}</td></tr>
						<tr><td class="tField">Category</td><td>{{item.category}}</td></tr>
						<tr><td class="tField">Tags</td><td>{{item.tags}}</td></tr>
						<tr><td class="tField">File Size</td><td>{{item.size}}</td></tr>
						<tr><td class="tField">Modified</td><td>{{item.mtime}}</td></tr>
						<tr><td class="tField">Created</td><td>{{item.ctime}}</td></tr>
						<tr><td class="tField">Added</td><td>{{item.added}}</td></tr>
						<tr><td class="tField">Profile</td><td>{{item.profile}}</td></tr>
						<tr><td class="tField">Duration</td><td>{{item.duration}}</td></tr>
						<tr><td class="tField">Width</td><td>{{item.width}}</td></tr>
						<tr><td class="tField">Height</td><td>{{item.height}}</td></tr>
						<tr><td class="tField">Frame Rate</td><td>{{item.frameRate}}</td></tr>
						<tr><td class="tField">Bitrate</td><td>{{item.bitrate}}</td></tr>
						<tr><td class="tField">Frame mode</td><td>{{item.frameMode}}</td></tr>
						<tr><td class="tField">Standard</td><td>{{item.standard}}</td></tr>
						<tr><td class="tField">Scan type</td><td>{{item.scanType}}</td></tr>
						<tr><td class="tField">Aspect</td><td>{{item.aspect}}</td></tr>
					</table>
					<div width="100%" style="display:inline;float:right;padding-left:8px">
						Notes<br><textarea rows="20" cols="50" class="notes" :name="item.name"></textarea>
						<button @click="saveNote($event)">Save</button>
					</div>
					
				</table>
			</div>
			</transition>
		</div>
	</div>
	<div v-if="!searchResult.length"><h1>No result</h1></div>
	<br>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data () {
	return {
	  searchResults: [],
	  searchResult: [],
	  pages: 0,
	  perpage: 25,
	  show: [],
	  sortMethod: 'date',
	  searchOccurs: false
	}
  },
  methods: {
	saveNote($event) {
		//console.log($event)
		var textArea = $event.target.previousElementSibling
		var text = textArea.value
		var name = textArea.attributes.name.value
		//save notes
		this.axios.post(this.$bus.mamServer+"/saveNote",{name,text}).then((result)=>{

			var data = result.data
			if (data.status==="success"){
				console.log("save note succeeded...")
			}
		}).catch((err)=>{
			console.log(err)
		})
	},
	changePage(n){
		var start = n===1?0:(n-1)*this.perpage-1
		this.searchResult=this.searchResults.slice(start,start+this.perpage)
		document.getElementsByClassName("pageNumberSelected")[0].classList.remove("pageNumberSelected")
		document.getElementsByName("page"+n)[0].classList.add("pageNumberSelected")
	},
	getNote(name) {
		this.axios.post(this.$bus.mamServer+"/getNote",{name}).then((result)=>{

			var data = result.data
			if (data.status==="success") document.getElementsByName(name)[0].value=data.text

		}).catch((err)=>{
			console.log(err)
		})
	},
	expandItem: {
	},
	toggle(index){
		let display = !this.show[index]
		
		if (display){
			this.show.forEach((item,index)=>{
				this.show[index] = false
			})
			if (!this.searchOccurs) this.getNote(this.searchResult[index].name)
		}
		this.show[index] = display
		this.show = [...this.show]
	},
	download(path,location){
		
		path = path.replace(/\\/g,"/")
		var filename = path.substring(path.lastIndexOf("/")+1)
		path = encodeURI(path)
	
		this.axios.post(this.$bus.mamServer+"/download",{path,location}).then((result)=>{

			var data = result.data
			console.log(result)
			if (data.status==="success"){
				var dlink = document.createElement("a")
				var url = (result.data.link).replace("sharing","fsdownload")+"/"+encodeURI(filename)
				window.open(url,"download","width=300,height=250")
			}
		}).catch((err)=>{
			console.log(err)
		})
	}
  },
  created(){
  	
	this.$bus.$on("searchChanged",(data)=>{
	
		this.searchResult = [] //clear 

		this.axios.post(this.$bus.mamServer+"/find",data).then((result)=>{
			
			if (!result.data.length) return //no result..
			result.data.forEach((item,index)=>{
				this.show[index] = false
			})
			
			//search for occurences???
			if (result.data[0].multiple){
				this.searchOccurs = true

				if (result.data.length<this.perpage) {
					this.searchResults = []
					this.pages = 0
					this.searchResult = result.data
				}
				else {
					//create pages...
					this.pages = Math.floor(result.data.length/this.perpage)
					this.searchResults = result.data
					this.searchResult = this.searchResults.slice(0,this.perpage-1)
					document.getElementsByName("page1")[0].classList.add("pageNumberSelected")
				}
				return
			}
			else {
				this.searchOccurs = false
			}
			
			result.data.sort((a,b)=>{
				switch (this.sortMethod){
					case "date": return (new Date(b.ctime) - new Date(a.ctime))
					case "default": return a.name>b.name
				}
			})
			
			if (result.data.length<this.perpage) {
				this.searchResults = []
				this.pages = 0
				this.searchResult = result.data
			}
			else {
				//create pages...
				this.pages = Math.floor(result.data.length/this.perpage)
				this.searchResults = result.data
				this.searchResult = this.searchResults.slice(0,this.perpage-1)
				document.getElementsByName("page1")[0].classList.add("pageNumberSelected")
			}

		}).catch((err)=>{
			console.log(err)
		})
	})
	
	if (!this.$bus.login) return this.$router.push("/")
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.searchOuter{
	margin-right:30px;
}

.searchItem{
	background-color:#5276af;
	margin: 5px;
	text-align: left;
	width: 100%;
	border-radius: 5px;
	padding: 2px;
}

.searchItem:hover{
	background-color:#a9c5f2;
	cursor:pointer;
	border: 2px solid blue;
}
.itemProperties{
	border-radius:5px;
	background-color:lightblue;
	padding:5px;
}

.editButton{
	float:right;
	margin:5px;
	margin-right: 20px;
}
button{
	border-radius:5px;
}
button:hover{
	background-color: lightgreen;
}

.tField{
	background-color:#809dcc;
}
.searchItemName{
	color: white;
}

.dropdown-enter-active, .dropdown-leave-active {
	max-height:400px;
	transition: all .5s;
}
.dropdown-enter, .dropdown-leave-to /* .fade-leave-active below version 2.1.8 */ {
  max-height:0;
  opacity: 0;
}
.location{
	color:orange;
	display: inline;
}
.pageNumber{
	background-color:lightgray;
	margin:2px;
	padding:5px;
	border-radius:2px;
	font-size: 18px;
}
.pageNumber:hover{
	cursor:pointer;
	background-color: green;
}
.pageNumberSelected{
	background-color:gray;
	border: 1px solid red;
}
textarea
{
  width:100%;
  margin:5px 0;
  padding:3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue